module.exports = __webpack_public_path__ + "img/opp111.bd9200ff.png";